export const STICKY_NAV_BAR = {
  STICKY_NAV_BAR_SET_SELECTED: "STICKY_NAV_BAR_SET_SELECTED",
  STICKY_NAV_BAR_CLEAR_SELECTED: "STICKY_NAV_BAR_CLEAR_SELECTED",
};
